const NoResult = ({ colSpan }) => (
  <tr>
    <td colSpan={colSpan} style={{ padding:50}}>
      No Result Found
    </td>
  </tr>
);

export default NoResult;
